module.exports = __webpack_public_path__ + "static/img/8.97ec7233.png";